module.exports = __webpack_public_path__ + "static/ftp_smallBanner-c78870c086fd7f9676b1a8ebf1eff470.png";